module.exports = __webpack_public_path__ + "static/media/40.eebd1898.jpg";